import React from 'react'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '../../../components/ui/dialog'
import { Button } from '../../../components/ui/button'
import { PaiementSOL } from '../../../api/paiements.api'
import { formatCurrency } from '../../../utils/format'
import { formatDate } from '../../../utils/date'
import { Badge } from '../../../components/ui/badge'
import { Printer, Calendar, User, CreditCard, Hash, FileText } from 'lucide-react'

interface PaymentDetailsModalProps {
    isOpen: boolean
    onClose: () => void
    paiement: PaiementSOL | null
    onPrint?: (paiement: PaiementSOL) => void
}

export function PaymentDetailsModal({
    isOpen,
    onClose,
    paiement,
    onPrint,
}: PaymentDetailsModalProps) {
    if (!paiement) return null

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold flex items-center gap-2">
                        <FileText className="h-5 w-5 text-primary" />
                        Detay Paiement
                    </DialogTitle>
                    <DialogDescription>
                        ID: <span className="font-mono text-xs">{paiement.id}</span>
                    </DialogDescription>
                </DialogHeader>

                <div className="grid grid-cols-2 gap-6 py-4">
                    {/* Client Info */}
                    <div className="space-y-4 col-span-2 sm:col-span-1">
                        <h4 className="text-sm font-semibold text-muted-foreground flex items-center gap-1.5">
                            <User className="h-4 w-4" /> Enfo Kliyan
                        </h4>
                        <div className="bg-muted/50 p-3 rounded-md space-y-2">
                            <div>
                                <span className="text-xs text-muted-foreground block">Non Kliyan</span>
                                <span className="font-medium text-sm">{paiement.client_nom || 'N/A'}</span>
                            </div>
                            <div>
                                <span className="text-xs text-muted-foreground block">Kòd Kont</span>
                                <span className="font-medium font-mono text-sm">{paiement.compte_code || 'N/A'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Payment Info */}
                    <div className="space-y-4 col-span-2 sm:col-span-1">
                        <h4 className="text-sm font-semibold text-muted-foreground flex items-center gap-1.5">
                            <CreditCard className="h-4 w-4" /> Enfo Paiement
                        </h4>
                        <div className="bg-muted/50 p-3 rounded-md space-y-2">
                            <div>
                                <span className="text-xs text-muted-foreground block">Montan Peye</span>
                                <span className="font-bold text-lg text-green-600">
                                    {formatCurrency(paiement.montant)}
                                </span>
                            </div>
                            <div>
                                <span className="text-xs text-muted-foreground block">Kantite Men</span>
                                <span className="font-medium flex items-center gap-1">
                                    <Hash className="h-3 w-3" /> {paiement.nb_main}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Meta Info */}
                    <div className="space-y-4 col-span-2">
                        <h4 className="text-sm font-semibold text-muted-foreground flex items-center gap-1.5">
                            <Calendar className="h-4 w-4" /> Lòt Detay
                        </h4>
                        <div className="bg-muted/50 p-3 rounded-md grid grid-cols-2 gap-4">
                            <div>
                                <span className="text-xs text-muted-foreground block">Dat Kreyasyon</span>
                                <span className="text-sm">{formatDate(paiement.created_at)}</span>
                            </div>
                            <div>
                                <span className="text-xs text-muted-foreground block">Dènye Mizajou</span>
                                <span className="text-sm">{paiement.updated_at ? formatDate(paiement.updated_at) : 'N/A'}</span>
                            </div>
                            <div>
                                <span className="text-xs text-muted-foreground block">Kreye pa (Agent ID)</span>
                                <span className="text-sm font-mono">{paiement.created_by_id || 'System'}</span>
                            </div>
                            <div>
                                <span className="text-xs text-muted-foreground block">Estati</span>
                                <Badge variant="outline" className="text-green-600 border-green-600 bg-green-50 mt-1">
                                    Reussi
                                </Badge>
                            </div>
                        </div>
                    </div>
                </div>

                <DialogFooter className="gap-2 sm:gap-0">

                    <Button onClick={onClose}>Fèmen</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
